<template>

  <div class="all_list_box" :style="list_show?'width:0;':''">
      <div class="list_tit" >
          <span class="tit_text">更换车型</span>
      </div>
      <div class="list_items" >
        <template v-for="(item,ind) in model_list" :key="ind">
            <div :class="cur_id == item.id ? 'list_item active':'list_item'" @click="changeModel(item)">
                <div class="item_img">
                    <img :src="item.model_img" alt="">
                </div>
                <div class="item_name">
                    {{item.brand}} {{item.model_name}}
                </div>
            </div>
        </template>
      </div>
      <div class="show_list" @click="list_show=!list_show">
          <span :class="!list_show?'show_icon':'show_icon close'"></span>
      </div>
  </div>
</template>

<script>
import {
    getCarLibraryV2
} from "@/api";
import {
    getCarLibrary as getCarLibraryV22
} from "@/api_drive";
import { ref ,toRef} from "vue";
import {useRouter} from "vue-router";
export default {
    name:"ModelList",
    props: {
        curid: {
            default:''
        },
        list:{
            default:[]
        },
        from:{
            default:''
        },
        route_type:{
            default:''
        }
    },
    setup(props,ctx){
        let model_list = ref([]);
        let list_show = ref(true);
        const cur_id = toRef(props, 'curid')
        if(props.list && props.list.length>0){
            let list = JSON.parse(JSON.stringify(props.list));
            model_list.value = list.map(item=>{
                return {
                    brand:item.car_info.brand,
                    model_name:item.car_info.model_name,
                    model_img:item.car_info.model_img,
                    id:item.car_info.model_id,
                }
            })
        }else{
            if(props.route_type == "drive"){
                getCarLibraryV22({
                    page:1,
                    rows:999
                }).then(res=>{
                    model_list.value = res.data.list;
                    console.log(res.data.list)
                })
            }else{
                getCarLibraryV2({
                    page:1,
                    rows:999
                }).then(res=>{
                    model_list.value = res.data.list;
                    console.log(res.data.list)
                })
            }
            
           
        }
       
        let router = useRouter();

        let changeModel = (data)=>{
            if(props.from && props.from == "first"){
                router.replace({
                    path:props.route_type=="drive"?"/drive"+"/summary/first":"/summary/first",
                    query:{
                        model_img:data.model_img,
                        model_name:data.model_name||data.model_name,
                        model_id:data.id,
                        report_id:data.report_id,
                    }
                })
            }
             ctx.emit("changeModel",data.id)
        }
        return {
            model_list,
            list_show,
            changeModel,
            cur_id
        }
    }
}
</script>

<style lang="less" scoped>
.all_list_box{
    width: 240px;
    position: fixed;
    top: 120px;
    right: 0;
    z-index: 10;
    background: #fff;
    box-shadow: 0 0 5px 2px #f5f5f5;
    border-radius: 5px;
    transition: width 500ms;
    .list_tit{
        width: 100%;
        height: 43px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px 23px 10px 28px;       
        border-radius: 5px;
        cursor: pointer;
        white-space: nowrap;
        .tit_text{
            font-size: 16px;
        }
       
    }
    .list_items{
        width: 100%;
        height: auto;
        max-height: 360px;
        overflow-x: hidden;
        overflow-y: auto;
        padding: 0 13px 10px;
        .list_item{
            width: 214px;
            padding:20px 8px 10px 8px;
            display: flex;
            justify-content: space-between;
            position: relative;
            cursor: pointer;
            &.active{
                background: #f8fbff;
            }
            // &::after{
            //     content: "";
            //     width: 185px;
            //     height: 7px;
            //     background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/c0b7ced4e3b65402b24d85021747aef5.png) no-repeat;
            //     background-size: 100%;
            //     position: absolute;
            //     left: 50%;
            //     bottom: -7px;
            //     transform: translateX(-50%);
            // }
            &:hover{
                background: #f9f9f9;
            }
            &:last-child::after{
                width: 0;
                height: 0;
            }
            .item_img{
                height: 42px;
                width: 63px;
                flex-shrink: 0;
                overflow: hidden;
            
                img{
                    width: 100%;
                    height: 100%;
                    object-fit: contain;
                }
            }
            .item_name{
                flex-grow: 1;
                padding: 0 5px;
                font-size: 12px;
                line-height: 15px;
            }

        }
    }

    .show_list{
        width: 30px;
        height: 60px;
        line-height: 60px;
        background: #fff;
        border-radius: 30px 0 0 30px;
        position: absolute;
        left: -30px;
        top: 50%;
        transform: translateY(-50%);
        box-shadow: -4px 0 5px 2px #f5f5f5;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        .show_icon{
            display: block;
            width: 30px;
            height: 30px;
            background: url("//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/f14c246145d8456bd432ed020069b4b5.png") no-repeat top center;
            background-size: 25px;
            transform:rotatez(90deg);
            transition:transform 500ms;
            &.close{
                transform:rotatez(270deg);
                margin-left: 10px;

            }
        }
    }
    
}

</style>